import { TransmissionTowerImportIcon } from './TransmissionTowerImportIcon';

/**
 * author: Michael Irigoyen
 * id 7CCBC365-A3F5-46BA-869B-AADA93F5D027
 * name transmission-tower-import
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/transmission-tower-import.svg
 * tags
 * - Home Automation 
 */
export const PowerToGridIcon = TransmissionTowerImportIcon;
export default PowerToGridIcon